<script setup lang="ts">
import emptyImg from '@/assets/imgs/empty.png'

withDefaults(defineProps<{
  isConnected?: boolean
}>(), {
  isConnected: true,
})
</script>

<template>
  <div class="empty-wrapper flex flex-col items-center mt-20px">
    <img :src="emptyImg" class="lt-tablet:h-80px h-150px opacity-60%">
    <div class="text-16px mt-8px text-[#8098bf] lt-tablet:text-14px">
      <slot>
        <div v-if="isConnected">{{ $t("Q8smHu0l0nMmaFpE7_DHE") }}</div>
        <div v-else>
          {{ $t("s-g1lDjln7jTc4kzSCohl") }}
          <a data-test-id="kiwi" @click="globalModal.ConnectWallet?.open()">{{ $t("FVtv_iILMub0tqoKdx_Oq") }}</a>
        </div>
      </slot>
    </div>
  </div>
</template>
